// Components==============
import { useLayoutEffect, useState } from 'react';
// =========================

export function useMeasure() {
    const [bounds, setBounds] = useState({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    });

    const body = document.querySelector('body');

    const [resizeO] = useState(
        () =>
            new ResizeObserver(([entry]) => {
                setBounds(entry.contentRect);
            })
    );

    useLayoutEffect(() => {
        if (body) {
            resizeO.observe(body);
        }

        return () => {
            resizeO.disconnect();
        };
    }, [resizeO, body]);

    return bounds;
}
